import React, {Component} from 'react';
import L from 'leaflet';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import ReactPopup from "react-leaflet-popup";

@propTypes({
    map: PropTypes.object.isRequired,
    leafletMap: PropTypes.object.isRequired,
    geometry: PropTypes.object.isRequired,
    tooltip: PropTypes.string,
    bringToBack: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.func
    ]),
    label: PropTypes.string,
    interactive: PropTypes.bool,
    permanentTooltip: PropTypes.bool,
    onClick: PropTypes.func,
    popup: PropTypes.func,
    popupOffset: PropTypes.number,
    popupWidth: PropTypes.number,
    onMouseOver: PropTypes.func,
    onMouseOut: PropTypes.func,
    color: PropTypes.string,
    weight: PropTypes.number,
    fillOpacity: PropTypes.number,
    opacity: PropTypes.number,
})

@defaultProps({
    tooltip: null,
    bringToBack: false,
    label: null,
    interactive: true,
    permanentTooltip: false,
    onClick: null,
    popup: null,
    popupOffset: -250,
    popupWidth: 350,
    color: 'blue',
    weight: 3,
})

export default class MapGeojson extends Component {

    __layer = null;

    componentWillMount() {
        this.__layer = new L.GeoJSON(this.props.geometry, this.getOptions());

        if (this.props.onClick) {
            this.getLayer().on('click', this.props.onClick);
        }
        if (this.props.onMouseOver) {
            this.getLayer().on('mouseover', this.props.onMouseOver);
        }
        if (this.props.onMouseOut) {
            this.getLayer().on('mouseout', this.props.onMouseOut);
        }

        if (this.props.tooltip) {
            this.getLayer().bindTooltip(this.props.tooltip, {
                sticky: true,
                permanent: this.props.permanentToolTip,
                interactive: !!this.props.onClick,
            });
        }

        if (this.props.label) {
            this.getLayer().addLayer(new L.tooltip({
                permanent: true,
                direction: 'center',
                className: 'leaflet-tooltip-own'
            })
                .setContent(this.props.label)
                .setLatLng(this.__layer.getBounds().getCenter()));
        }

        if (this.props.popup && (this.props.onClick === null)) {
            this.getLayer().on('click', ::this.loadPopup)
        }
    }

    getOptions() {
        return {
            interactive: this.props.interactive,
            style: this.getStyle(this.props),
        };
    }

    componentDidMount() {
        this.props.leafletMap.addLayer(this.getLayer());
        if (this.props.bringToBack) {
            this.getLayer().bringToBack();
        }
    }

    componentWillUnmount() {
        this.props.leafletMap.removeLayer(this.getLayer());
    }

    componentWillUpdate(props) {
        if (this.props.geometry !== props.geometry) {
            const layer = this.getLayer();
            layer.clearLayers();
            layer.addData(props.geometry);
        }
        if (props.onClick !== this.props.onClick) {
            this.props.onClick && this.getLayer().off('click', this.props.onClick);
            props.onClick && this.getLayer().on('click', props.onClick);
        }
        this.getLayer().setStyle(this.getStyle(props));
    }

    getStyle(props = null) {
        if (props.fillOpacity >= 0) {
            return {
                fillOpacity: 0,
                color: '#EEDDD9',
                opacity: 1,
                weight: props.weight,
            };
        } else {
            return {
                color: this.getColor(props),
                opacity: this.props.opacity ? this.props.opacity : 0.6,
                weight: props.weight,
            };
        }

    }

    getColor(props) {
        const color = props ? props.color : this.props.color;
        switch (color) {
            case 'blue':
                return '#0000FF';
            case 'gray':
                return '#333';
            case 'green':
                return '#00FF00';
            case 'red':
                return '#FF0000';
            default:
                return color || '#FF0000';
        }
    }

    getLayer() {
        return this.__layer;
    }

    render() {
        return null;
    }

    loadPopup() {
        const layer = this.getLayer();
        layer.unbindPopup();
        layer.closePopup();
        layer.bindPopup(
            this.createPopup(::layer.closePopup)
        );
        layer.openPopup();
    }

    createPopup(onClose) {
        return new ReactPopup({
            reactComponent: Popup,
            reactComponentProps: {
                ...this.props,
                onClose
            },
            minWidth: this.props.popupWidth ? this.props.popupWidth : 434,
            maxWidth: 434,
            offset: new L.Point(3, this.props.popupOffset),
        });
    }
}

class Popup extends Component {
    render() {
        return this.props.popup(this.props.onClose);
    }
}


// WEBPACK FOOTER //
// ./src/components/ui/map/base/geojson.js